// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2dOXI","inputWrap":"styles_inputWrap__3tAjJ","input":"styles_input__2dWjF"};